﻿/**
 * Kết quả kiểm tra công thức
 * ltviet 18.03.2024
 */
export default {
  /// <summary>
  /// công thức chưa kiểm tra
  /// </summary>
  Unchecked: 0,

  /// <summary>
  /// Công thức hợp lệ
  /// </summary>
  Valid: 1,

  /// <summary>
  /// Công thức chưa hợp lệ
  /// </summary>
  Invalid: 2,
  /// <summary>
  /// Công thức sai mã
  /// </summary>
  WrongCode: 3,
};
